import { DispatcherEvent } from '@carvana/merch-native';
import { useContext } from 'react';
import FavoritesContext from '~/contexts/FavoritesContext';
import ModalContext from '~/contexts/ModalContext';
import { useTileDataContext } from '~/contexts/TileDataContext';
import UserContext, { useUserData } from '~/contexts/UserContext';
import useOpenAccountModal from '~/hooks/useOpenAccountModal';
import sendMessageToNative from '~/native/dispatchers/sendMessageToNative';

const withHandleFavorite = FavoriteComponent => {
  return props => {
    const { isLoggedIn } = useUserData();
    const { tileData } = useTileDataContext();
    const { addFavorite, removeFavorite, setModalVehicleId } =
      useContext(FavoritesContext);
    const { setWipNotificationModalOpen } = useContext(ModalContext);
    const { triggerFetchUserProfile } = useContext(UserContext);
    const openAccountModal = useOpenAccountModal();
    const {
      vehicleId = 0,
      isFavorite: hasBeenFavorited = false,
      isOnDemand: showWIPNotification = false
    } = tileData;

    const displayWIPModal = () => setWipNotificationModalOpen(true);

    const successHandler = async () => {
      triggerFetchUserProfile();
      if (showWIPNotification) {
        displayWIPModal();
      } else {
        addFavorite({ vehicleId });
      }
    };

    const loginAndFavorite = () => {
      openAccountModal({
        modalTitle: 'SAVE TO FAVORITES',
        callerIdentifier: 'Favorites',
        onSuccess: successHandler
      });
      sendMessageToNative(DispatcherEvent.AddFavorite, { vehicleId });
    };

    const actionRequired = () => {
      switch (true) {
        case !isLoggedIn:
          return loginAndFavorite();
        case hasBeenFavorited:
          return removeFavorite({
            vehicleId
          });
        case showWIPNotification:
          return displayWIPModal();
        default:
          return addFavorite({ vehicleId });
      }
    };

    const handleFavorite = () => {
      setModalVehicleId(vehicleId);
      actionRequired();
    };

    return <FavoriteComponent handleFavorite={handleFavorite} {...props} />;
  };
};

export default withHandleFavorite;
